import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { handleListResponse, seo } from "utils/utils";
import {
  createCpAppointment,
  getCPAppointmentList,
  editCpAppointment,
} from "reduxStore/action/userAppointmentAction";
import { getAssignCPList } from "reduxStore/action/channelPartnerAction";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { handleDetailResponse, isEmpty } from "../../utils/utils";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import { getMasterList } from "reduxStore/action/masterActions";
import { SiteHead } from "../../utils/constants";
import { getAllProperty } from "reduxStore/action/propertyActions";
import Select from "react-select";

const AddAppointmentWithCp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const [apiResponse, setApiResponse] = useState([]);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const [cpAppointmentList, setCpAppointmentList] = useState([]);
  const [appointmentType, setAppointmentType] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const params = new URLSearchParams(window.location.search);
  const appointment_id = params.get("appointment_id");

  const { response: res } = useSelector((state) => state.login);

  const cpUserList = useSelector((state) => state.channelPartner);
  const propertySelector = useSelector((state) => state.propertyData) || {};

  const user_id = res?.data?._id;

  const siteHead = SiteHead === res?.data?.role_id;

  useEffect(() => {
    if (!appointment_id) {
      const fetchData = async () => {
        try {
          // Dispatch the first action to get the assign CP list
          await dispatch(getAssignCPList({ user_id }));
          // After the first action completes, dispatch the next actions
          await dispatch(getMasterList({ type: 9 }));
          // After the second action completes, dispatch the third action
          await dispatch(getCPAppointmentList({ appointment: 2 }));
          await dispatch(getAllProperty());
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    } else {
      dispatch(getAssignCPList({ user_id }));
      dispatch(getMasterList({ type: 9 }));
      dispatch(getCPAppointmentList({ appoiment: 2 }));
      dispatch(getAllProperty());
    }
  }, [appointment_id, dispatch, user_id]);

  useEffect(() => {
    if (appointment_id) {
      setForm({ ...form, appointment_id: appointment_id });
    }
  }, [appointment_id]);

  const addAppointmentSelector = useSelector((state) => state?.cpAppointment);

  const appointmentTypeSelector = useSelector((state) => state.masterData);
  // const handleInputArea = (e) => {
  //   const nextFormState = {
  //     ...form,
  //     pickup_location: e,
  //     pickup_latitude: "",
  //     pickup_longitude: "",
  //   };
  //   setForm(nextFormState);
  // };
  // const onSelect = (latLng, pickup_location) => {
  //   const nextFormState = {
  //     ...form,
  //     pickup_location: pickup_location,
  //     pickup_latitude: latLng.lat,
  //     pickup_longitude: latLng.lng,
  //   };
  //   setForm(nextFormState);
  // };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (appointment_time) => {
    let formErr = { ...formVaild };
    if (appointment_time) {
      const nextFormState = {
        ...form,
        appointment_time: moment("2000-01-01 " + appointment_time).format(
          "hh:mm A"
        ),
      };
      setForm(nextFormState);

      if (!isEmpty(formErr?.appointment_time)) {
        delete formErr.appointment_time;
      }
    } else {
      formErr["appointment_time"] = strings.validTime;
    }
    setFormVaild(formErr);
  };

  useEffect(() => {
    const {
      response = null,
      create = false,
      edit = false,
    } = addAppointmentSelector;

    if (response && response?.status === 200) {
      if (!create && !edit && response.data?.length > 0) {
        const filteredAppointments = response.data.filter(
          (item) => item._id === appointment_id // Only select appointments matching the appointment_id
        );

        setCpAppointmentList(
          handleListResponse(filteredAppointments) ? filteredAppointments : []
        );

        setForm((prevForm) => {
          // Compare if the form data has changed to avoid unnecessary re-renders
          if (
            prevForm.first_name !== cpAppointmentList[0]?.receiver_name ||
            prevForm.last_name !== cpAppointmentList[0]?.sender_id
            // add more comparisons as necessary for other fields
          ) {
            return {
              ...prevForm,
              _id: cpAppointmentList[0]?._id,
              sender_id: cpAppointmentList[0].sender_id,
              receiver_id: cpAppointmentList[0].receiver_id,
              appointment_type: cpAppointmentList[0].appointment_type,
              appointment_date: moment(
                cpAppointmentList[0]?.appointment_date
              ).format("YYYY-MM-DD"),
              appointment_time: cpAppointmentList[0].appointment_time,
              latitude: cpAppointmentList[0].latitude,
              longitude: cpAppointmentList[0]?.longitude,
              status: cpAppointmentList[0]?.status,
              appointment_status: cpAppointmentList[0]?.appointment_status,
              remark: cpAppointmentList[0]?.remark,
              confirm_remark: cpAppointmentList[0]?.confirm_remark,
              cancle_remark: cpAppointmentList[0]?.cancle_remark,
              compleate_remark: cpAppointmentList[0]?.compleate_remark,
              create_Date: cpAppointmentList[0]?.create_Date,
              cancle_date: cpAppointmentList[0]?.cancle_date,
              appointment_cancle_by:
                cpAppointmentList[0]?.appointment_cancle_by,
              sender_name: cpAppointmentList[0]?.sender_name,
              receiver_name: cpAppointmentList[0]?.receiver_name,
              appointment_type_title:
                cpAppointmentList[0]?.appointment_type_title,
              cp_location: cpAppointmentList[0]?.cp_location,
              property_id: cpAppointmentList[0]?.property_id,
              registered_cp: cpAppointmentList[0]?.registered_cp,
              non_reg_cp_name: cpAppointmentList[0]?.receiver_name,
              non_reg_cp_mobile: cpAppointmentList[0]?.non_reg_cp_mobile,
              non_reg_cp_email: cpAppointmentList[0]?.non_reg_cp_email,
            };
          }
          return prevForm; // Don't update if there is no change
        });
      }
    } else {
      setCpAppointmentList([]);
    }
  }, [addAppointmentSelector, appointment_id]); // Add appointment_id as a dependency

  useEffect(() => {
    if (propertySelector.response) {
      if (
        propertySelector?.response &&
        propertySelector?.response.status === 200
      ) {
        const filteredData = propertySelector?.response?.data?.filter(
          (item) => item.status === true
        );
        if (filteredData?.length > 0) {
          setPropertyList(handleListResponse(filteredData));
        } else {
          setPropertyList([]); // Clear the list if no valid data
        }
      } else {
        setPropertyList([]);
      }
    }
  }, [dispatch, propertySelector]);

  useEffect(() => {
    if (appointmentTypeSelector.response) {
      const { response } = appointmentTypeSelector;
      if (response?.status === 200) {
        setAppointmentType(handleListResponse(response.data));
      } else {
        setAppointmentType([]);
      }
    }
  }, [appointmentTypeSelector]);

  useEffect(() => {
    if (cpUserList?.response?.status === 200) {
      setAgentList(cpUserList?.response?.data);
    } else {
      setAgentList([]);
    }
  }, [cpUserList]);

  useEffect(() => {
    if (
      addAppointmentSelector.create === true ||
      addAppointmentSelector.edit === true
    ) {
      if (addAppointmentSelector?.response?.status === 200) {
        setForm({});
        navigatpage("/appointment_with_cp");
      }
    }
  }, [addAppointmentSelector]);

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      form.appointment_date &&
        formData.append("appointment_date", form.appointment_date);
      form.appointment_time &&
        formData.append("appointment_time", form.appointment_time);
      form.appointment_with &&
        formData.append("appointment_with", form.appointment_with);
      form.appointment_type &&
        formData.append("appointment_type", form.appointment_type);
      form.property_id && formData.append("property_id", form.property_id);
      form.registered_cp &&
        formData.append("registered_cp", form.registered_cp);
      if (form.registered_cp == "2" || form.registered_cp == "3") {
        form.non_reg_cp_name &&
          formData.append("non_reg_cp_name", form.non_reg_cp_name);
        form.non_reg_cp_mobile &&
          formData.append("non_reg_cp_mobile", form.non_reg_cp_mobile);
        form.non_reg_cp_email &&
          formData.append("non_reg_cp_email", form.non_reg_cp_email);
      }

      if (appointment_id) {
        formData.append("appointment_id", cpAppointmentList[0]._id);
        dispatch(editCpAppointment(formData));
      } else {
        dispatch(createCpAppointment(formData));
      }
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;

    if (!form.appointment_date) {
      formError = true;
      err["appointment_date"] = strings.followup_dateErr;
    }
    if (!form.appointment_time) {
      formError = true;
      err["appointment_time"] = strings.followup_timeErr;
    }
    if (!form.registered_cp === "2" || !form.registered_cp === "3") {
      if (!form.appointment_with) {
        formError = true;
        err["appointment_with"] = strings.appointmentWithErr;
      }
    }
    if (!form.appointment_type) {
      formError = true;
      err["appointment_type"] = strings.appointmentTypeErr;
    }
    if (form.registered_cp === "2" || form.registered_cp === "3") {
      if (!form.non_reg_cp_name) {
        formError = true;
        err["non_reg_cp_name"] = "Please enter the name of the CP.";
      }
      if (!form.non_reg_cp_mobile) {
        formError = true;
        err["non_reg_cp_mobile"] = "Please enter the mobile number.";
      } else if (!/^\d{10}$/.test(form.non_reg_cp_mobile)) {
        formError = true;
        err["non_reg_cp_mobile"] =
          "Please enter a valid 10-digit mobile number.";
      }

      if (
        form.non_reg_cp_email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.non_reg_cp_email)
      ) {
        formError = true;
        err["non_reg_cp_email"] = "Please enter a valid email address.";
      }
    }

    // if (form.pickup === "Yes") {
    //   if (!form.pickup_location) {
    //     formError = true;
    //     err["pickup_location"] = strings.pickupLocationErr;
    //   }
    //   if (!form.pickup_address) {
    //     formError = true;
    //     err["pickup_address"] = strings.addressErr;
    //   }
    //   if (!form.number_of_guest) {
    //     formError = true;
    //     err["number_of_guest"] = strings.numberOfGuest;
    //   } else if (isNaN(form.number_of_guest)) {
    //     formError = true;
    //     err["number_of_guest"] = strings.validNumber;
    //   }
    // }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Add Appointment",
      metaDescription: "Add appointment details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={
          appointment_id ? strings.editAppointment : strings.addAppointment
        }
        url={"/appointment_with_cp"}
        parentListing={strings.appointmentListCP}
        titleactive={
          appointment_id ? strings.editAppointment : strings.addAppointment
        }
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>
                  {appointment_id
                    ? strings.editAppointment
                    : strings.addAppointment}
                </h5>
              </div>
              <div className="card-body">
                <div className="row ">
                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentDate}
                        <span className="required-field"></span>
                      </label>
                      <input
                        className="form-control"
                        id="exampleFormControlFirstName"
                        name="appointment_date"
                        type="Date"
                        min={moment().format("yyyy-MM-DD")}
                        value={form?.appointment_date}
                        onChange={handleInputField}
                      />
                      {formVaild?.appointment_date && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_date}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 ">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AppointmentTime}
                        <i
                          className="fa fa-info-circle pl-1 pr-1"
                          title={strings.AppointmentTimeDetail}
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                        ></i>
                        <span className="required-field"></span>
                      </label>
                      <TimePicker
                        onChange={handleInputTime}
                        value={form?.appointment_time}
                        clockIcon={null}
                        clearIcon={null}
                        disableClock={true}
                        format={"hh:mm a"}
                        className="form-control"
                        name="appointment_time"
                      />
                      {formVaild?.appointment_time && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_time}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="appointment_type">
                        {strings.appointmentType}
                        <span className="required-field"></span>
                      </label>
                      <select
                        name="appointment_type"
                        className="form-control"
                        value={form?.appointment_type}
                        onChange={handleInputField}
                      >
                        <option value="">{"Select Appointment Type"}</option>
                        {appointmentType.map((type) => (
                          <option
                            key={type._id}
                            value={type._id}
                            selected={form?.appointment_type === type._id}
                          >
                            {type.title}
                          </option>
                        ))}
                      </select>
                      {formVaild?.appointment_type && (
                        <span style={{ color: "red" }}>
                          {formVaild?.appointment_type}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-4">
                    <label htmlFor="exampleFormControlFirstName">
                      {strings.selectByPropertyName}
                    </label>
                    <Select
                      isSearchable
                      isClearable
                      placeholder={strings.selectByPropertyName}
                      options={propertyList}
                      getOptionLabel={(option) => `${option.property_title}`}
                      getOptionValue={(option) => option._id}
                      name="site"
                      value={
                        propertyList.find(
                          (option) => option._id === form.property_id
                        ) || null
                      }
                      onChange={(e) => {
                        if (e) {
                          setForm({
                            ...form,
                            property_id: e._id,
                          });
                        } else {
                          setForm({
                            ...form,
                            property_id: "",
                          });
                        }
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="cp_type">{strings.cpType}</label>
                      <span className="required-field"></span>
                      <select
                        className="form-control digits"
                        id="formcontrol-select1"
                        name="registered_cp"
                        value={form.registered_cp}
                        onChange={handleInputField}
                        disabled={appointment_id}
                      >
                        <option value={1}>{"Justo CP"}</option>
                        <option value={2}>{"Other CP"}</option>
                        <option value={3}>{"Referral Patner"}</option>
                      </select>
                    </div>
                  </div>

                  {!(form.registered_cp == "2" || form.registered_cp == "3") && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="appointment_with">
                          {strings.appointmentWith}
                          <span className="required-field"></span>
                        </label>
                        {appointment_id ? (
                          <input
                            type="text"
                            name="receiver_name"
                            className="form-control"
                            value={form?.receiver_name || ""}
                            onChange={handleInputField}
                            disabled // Disable the input field if appointment_id exists
                          />
                        ) : (
                          <select
                            name="appointment_with"
                            className="form-control"
                            value={form?.appointment_with}
                            onChange={handleInputField}
                            disabled={!!appointment_id} // Disable if appointment_id exists
                          >
                            <option value="">
                              {"Select Appointment With Cp"}
                            </option>
                            {agentList.map((agent) => (
                              <option
                                key={siteHead ? agent._id : agent.login_id}
                                value={siteHead ? agent._id : agent.login_id}
                              >
                                {agent.agent_name}
                              </option>
                            ))}
                          </select>
                        )}
                        {formVaild?.appointment_with && (
                          <span style={{ color: "red" }}>
                            {formVaild?.appointment_with}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {(form.registered_cp == "2" || form.registered_cp == "3") && (
                  <div className="row ">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="non_reg_cp_name">
                          {strings.nameOfCp}
                          <span className="required-field"></span>
                        </label>
                        <input
                          type="text"
                          name="non_reg_cp_name"
                          className="form-control"
                          placeholder={strings.name}
                          value={form.non_reg_cp_name || ""}
                          onChange={handleInputField}
                        />
                        {formVaild?.non_reg_cp_name && (
                          <span style={{ color: "red" }}>
                            {formVaild.non_reg_cp_name}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="non_reg_cp_mobile">
                          {strings.mobileNumber}
                          <span className="required-field"></span>
                        </label>
                        <input
                          type="text"
                          name="non_reg_cp_mobile"
                          className="form-control"
                          placeholder={strings.mobileNumber}
                          maxLength={10}
                          value={form.non_reg_cp_mobile || ""}
                          onChange={handleInputField}
                        />
                        {formVaild?.non_reg_cp_mobile && (
                          <span style={{ color: "red" }}>
                            {formVaild.non_reg_cp_mobile}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="non_reg_cp_email">
                          {strings.cpEmailAddress}
                        </label>
                        <input
                          type="email"
                          name="non_reg_cp_email"
                          className="form-control"
                          placeholder={strings.cpEmailAddress}
                          value={form.non_reg_cp_email || ""}
                          onChange={handleInputField}
                        />
                        {formVaild?.non_reg_cp_email && (
                          <span style={{ color: "red" }}>
                            {formVaild.non_reg_cp_email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleSubmit()}
                      >
                        {strings.submit}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddAppointmentWithCp;
